import "../../styles/components/ErrorLocation.css";
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import IErrorLocation from '../../components/icons/iErrorLocation'
import BButton from "../../components/general/BButton";
const ErrorLocation = ({ isModalOpen = false, onOK }) => {
  const handleOk = () => {
    onOK()
  };
  return (
    <>
      <Modal
        wrapClassName="modal-confirm-shift"
        open={isModalOpen}
        closable={false}
        onOk={handleOk} 
        maskClosable={false}
        footer={[]}
      >
        <div className="confirm-shift">
            <div className="icon"><IErrorLocation/></div>
            <h4>กรุณาเปิดการใช้งานตำแหน่งที่ตั้ง</h4>
            <div className="info-confirm">เราต้องการเข้าถึงตำแหน่งที่ตั้งของคุณ</div>
            <div className="info-confirm">เพื่อใช้สำหรับการเข้างาน - ออกงาน</div>
        </div>
        <div className="footer-confirm-shift">
          <BButton setStyle="outline confirm" onClick={handleOk}>ปิด</BButton>
        </div>
      </Modal>
    </>
  );
};
export default ErrorLocation;